import { CommonModule } from "@angular/common";
import { Component, ElementRef, inject, OnInit, ViewChild } from "@angular/core";
import {
  AbstractControl, ControlContainer, FormArray, FormControl, FormGroup, FormGroupDirective,
  ReactiveFormsModule,
  Validators
} from "@angular/forms";
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { MatCheckboxChange, MatCheckboxModule } from "@angular/material/checkbox";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialog } from "@angular/material/dialog";
import { MatExpansionModule, MatExpansionPanel } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatPaginator, MatPaginatorModule } from "@angular/material/paginator";
import { MatRadioChange, MatRadioModule } from "@angular/material/radio";
import { MatSelectChange, MatSelectModule } from "@angular/material/select";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatTimepickerModule } from "@angular/material/timepicker";
import { map, Observable, of, Subject, Subscription, takeUntil } from "rxjs";
import { AddressCategory } from "../../../dashboard/models/address-category";
import { AppointmentType } from "../../../dashboard/models/appointment-types";
import { DriverList } from "../../../dashboard/models/driver-list";
import { ProviderAddress } from "../../../dashboard/models/provider-adddress";
import { ExpenseType, HOME_ADDRESS_CATEGORY, TripDocumentsDto, TripRequestAddressCategoryModel, TripRequestStatus, TripRequestType, VerificationDocuments } from "../../../dashboard/models/trip-request-models";
import { ConsumerProfileService } from "../../../dashboard/profile/services/profile.service";
import { OTHER_ADDRESS_CATEGORY } from "../../../dashboard/profile/state/profile-model";
import { TripRequestService } from "../../../dashboard/services/trip-request.service";
import { PAGING_ROWS } from "../../../shared/constants/common-constants";
import { DecimalInputDirective } from "../../../shared/directives/decimal-input.directive";
import { AppointmentTimeMatcher, TouchedErrorStateMatcher } from "../../../shared/other/touched-form-error-state-matcher";
import { LookupsService } from "../../../shared/services/lookups-service";
import { futureDateValidator, futuretimeValidator, pastDateValidator, pasttimeValidator } from "../../../shared/validators/date-validators";
import { State } from "../../../state/lookups/lookups-model";
import { TripRequestFormFactory } from "../../shared/trip-request-form.factory";
import { TripRequestFormService } from "../../shared/trip-request-form.service";
import { WidgetComponent } from "../../widget/widget.component";

@Component({
  selector: 'app-trip-details',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatDatepickerModule,
    MatTimepickerModule,
    MatIcon,
    MatSelectModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    DecimalInputDirective,
    MatExpansionModule,
    MatTableModule,
    MatPaginatorModule
  ],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  templateUrl: './trip-details.component.html',
  styleUrl: './trip-details.component.scss',
})

export class TripDetailsComponent implements OnInit {
  @ViewChild('tollfileUpload')
  tollfileUpload!: ElementRef;
  @ViewChild('appointmentfileUpload')
  appointmentfileUpload!: ElementRef;
  @ViewChild('parkingfileUpload')
  parkingfileUpload!: ElementRef;
  private postTripRequestFormDir = inject(FormGroupDirective);
  private tripRequestFormFactory = inject(TripRequestFormFactory);
  private profileService = inject(ConsumerProfileService);
  private lookupService = inject(LookupsService);
  private tripRequestService = inject(TripRequestService);
  private tripRequestFormService = inject(TripRequestFormService);
  private dialog = inject(MatDialog);
  tripRequest!: FormGroup;
  appointmentDatesFr!: FormArray;
  tripPassengerFr!: FormArray;
  matcher = new TouchedErrorStateMatcher();
  appointmentMatcher = new AppointmentTimeMatcher();
  driverList$!: Observable<DriverList[]>;
  tripAddressFr!: FormArray;
  addressCategoryList$!: Observable<AddressCategory[]>;
  recipientaddressCategories$!: Observable<TripRequestAddressCategoryModel[]>;
  appointmentTypesList$!: Observable<AppointmentType[]>;
  addressCount= 0;
  providerAddress$: Observable<ProviderAddress[]>[] = [];
  showAppointmentType = false;
  filteredAddress$: Observable<string[]>[] = [];
  readonly homeAddressCategory = HOME_ADDRESS_CATEGORY;
  tollFileSelectPlaceHolder = "Upload Toll Receipts";
  appointmentFileSelectPlaceHolder = "Upload Appointment Documents";
  parkingFileSelectPlaceHolder = "Upload Parking Receipts";
  showTollSection = false;
  showParkingSection = false;
  appVerficationDocumentsDto: TripDocumentsDto[] = [];
  tollDocumentsDto: TripDocumentsDto[] = [];
  parkingDocumentsDto: TripDocumentsDto[] = [];
  stateList: State[] = [];
  private stateSub!: Subscription;
  private expenseAmountSub?: Subscription;
  private readonly destroy$ = new Subject<void>();
  recipientId = 0;
  countyCode = '';
  displayedColumns: string[] = ['confirmationNumber', 'fileNames'];
  linkingDocuments: VerificationDocuments[] = [];
  dataSource = new MatTableDataSource<VerificationDocuments>(this.linkingDocuments);
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  pageSize = PAGING_ROWS;
  preTripFlag = false;
  tripConfirmationNo = 'N/A';
  tripStatus = TripRequestStatus[TripRequestStatus.Unsubmitted];


  ngOnInit(): void {
    this.tripRequest = this.postTripRequestFormDir.form.get("tripRequest") as FormGroup;
    this.appointmentDatesFr = this.tripRequest.get("tripAppointments") as FormArray;
    this.tripPassengerFr = this.tripRequest.get("tripPassengers") as FormArray;
    this.tripAddressFr = this.tripRequest.get("tripAddresses") as FormArray;
    this.tripAddressFr.push(this.tripRequestFormFactory.getTripAddressFg(1));
    this.tripAddressFr.push(this.tripRequestFormFactory.getTripAddressFg(2));
    this.setAppointmentDateValidation(this.tripRequest.get("tripType")?.value);
    this.bindExpenceAmountChange();
  }

  getAppointmentExpense(index: number): FormArray {
      const appointmentGp = this.appointmentDatesFr.at(index) as FormGroup;
      return appointmentGp.get('tripExpenses') as FormArray;       
  }

  intializeTripEntryForm() {
    this.recipientId = Number(this.tripRequest.get('recipientId')?.value);
    this.tripRequestService.getPreTripFlag(this.recipientId).subscribe(data => {
      this.preTripFlag = data;
        if (this.preTripFlag) {
          this.tripRequest.get('tripType')?.setValue('Pre');
        }
    });
    this.driverList$ = this.profileService.getProfileSavedDrivers(this.recipientId);
    this.profileService.getRecipientCountyCode(this.recipientId).subscribe(data => {
      this.countyCode = data;
    });
    this.tripRequestService.getTripRate().subscribe(data => {
      this.tripRequestFormService.tripRate = data;
    });
    this.setAddressSearchList();
    this.appointmentTypesList$! = this.lookupService.getAppointmentTypes();
    this.recipientaddressCategories$! = this.tripRequestService.getTripRequestAddressCategories(this.recipientId);
    this.addressCategoryList$! = this.lookupService.getProfileAddressCategories();
    this.stateSub = this.lookupService.getStates().subscribe(data =>  {
          this.stateList = data;
    });

  }

  bindExpenceAmountChange() {
    this.expenseAmountSub?.unsubscribe();
    this.expenseAmountSub = this.appointmentDatesFr.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.updateExpenseSections());

    this.updateExpenseSections();
  }

  private updateExpenseSections(): void {
    const expenses = this.appointmentDatesFr.controls.flatMap((appointment) => {
      const expenseArray = appointment.get('tripExpenses') as FormArray;
      return expenseArray.controls;
    });

    this.showTollSection = expenses.some((expense) =>
      expense.get('expenseType')?.value === ExpenseType.Toll &&
      Number(expense.get('expenseAmount')?.value) > 0
    );
    this.showParkingSection = expenses.some((expense) =>
      expense.get('expenseType')?.value === ExpenseType.Parking &&
      Number(expense.get('expenseAmount')?.value) > 0
    );
  }

  onTripTypeChange(event: MatRadioChange<string>) {
    this.setAppointmentDateValidation(event.value);
  }

  addAppointment() {
    if (!this.tripRequest.get('isSameDriver')?.value) {
      const appointmentFg = this.tripRequestFormFactory.getPostTripAppointmentFg();
      appointmentFg.get('driverId')?.addValidators(Validators.required);
      this.appointmentDatesFr.push(appointmentFg);
    }
    else {
      this.appointmentDatesFr.push(this.tripRequestFormFactory.getPostTripAppointmentFg());
    }

    this.setAppointmentDateValidation(this.tripRequest.get('tripType')?.value);
  }

  setAppointmentDateValidation(tripType : string) {
    const validator = tripType === TripRequestType.Pre ? futuretimeValidator : pasttimeValidator;
    const dateValidator = tripType === TripRequestType.Pre ? futureDateValidator() : pastDateValidator();

    this.appointmentDatesFr.controls.forEach((appointment) => {
      appointment.get('appointmentDate')?.setValidators([Validators.required, dateValidator]);
      appointment.get('appointmentDate')?.updateValueAndValidity();
      appointment.setValidators(validator);
      appointment.updateValueAndValidity();
    });
  }

  removeAppointment(index: number) {
    if (this.appointmentDatesFr.length > 1) {
      this.appointmentDatesFr.removeAt(index);
    }
    else {
      this.tripRequest.get('isSameDriver')?.setValue(true);
      this.tripRequest.get('samePassenger')?.setValue(true);
    }
  }

  driverSelectionChange(event: MatSelectChange) {
    this.driverList$.pipe(
      map(items => items.find(item => item.id === event.value)))
        .subscribe(driver => {
            this.tripRequest.get('driverFirstName')?.setValue(driver?.firstName);
            this.tripRequest.get('driverLastName')?.setValue(driver?.lastName);
        }
    );
  }

  appointmentDriverSelectionChange(event: MatSelectChange, index: number) {
    this.driverList$.pipe(
      map(items => items.find(item => item.id === event.value)))
        .subscribe(driver => {
            this.appointmentDatesFr.at(index).get('driverFirstName')?.setValue(driver?.firstName);
            this.appointmentDatesFr.at(index).get('driverLastName')?.setValue(driver?.lastName);
        }
    );
  }

  onEnterDriverManual(event: Event ,index: number) {
    if (index === -1)
    {
      this.tripRequest.get('driverMannualEntry')?.setValue(true);
      this.tripRequest.get('driverFirstName')?.setValue(null);
      this.tripRequest.get('driverLastName')?.setValue(null);
    }
    else {
      this.appointmentDatesFr.at(index).get('driverMannualEntry')?.setValue(true);
      this.appointmentDatesFr.at(index).get('driverFirstName')?.setValue(null);
      this.appointmentDatesFr.at(index).get('driverLastName')?.setValue(null);
    }
  }

  onEnterDriverfromList (event: Event,index: number) {
    event.preventDefault();
    if (index === -1)
    {
      this.tripRequest.get('driverMannualEntry')?.setValue(false);
      this.tripRequest.get('saveDriverIntoProfile')?.setValue(false);
    }
    else {
        this.appointmentDatesFr.at(index).get('driverMannualEntry')?.setValue(false);
        this.appointmentDatesFr.at(index).get('saveDriverIntoProfile')?.setValue(false);
    }
  }

  addPassenger(index: number) {
      const appointmentGp = this.appointmentDatesFr.at(index) as FormGroup;
      const passengerArray = appointmentGp.get('appointmentPassengers') as FormArray;
      passengerArray.push(this.tripRequestFormFactory.getPassengerFg());
  }

  addTripPassenger() {
    const passengerArray = this.tripRequest.get('tripPassengers') as FormArray;
    passengerArray.push(this.tripRequestFormFactory.getPassengerFg());
  }

  removeTripPassenger(passengerIndex: number) {
      const passengerArray = this.tripRequest.get('tripPassengers') as FormArray;
      if (passengerArray.length > 1) {
        passengerArray.removeAt(passengerIndex);
      }
  }

  removePassenger(appointmentIndex: number, passengerIndex: number) {
    const appointmentGp = this.appointmentDatesFr.at(appointmentIndex) as FormGroup;
    const passengerArray = appointmentGp.get('appointmentPassengers') as FormArray;
    if (passengerArray.length > 1) {
      passengerArray.removeAt(passengerIndex);
    }
  }

  getPassenger(index: number): FormArray {
    const appointmentGp = this.appointmentDatesFr.at(index) as FormGroup;
    return appointmentGp.get('appointmentPassengers') as FormArray;
  }

  onSamePassengerChange($event: MatRadioChange<boolean>) {
    this.tripRequest.get("samePassenger")?.setValue($event.value)
  }

  onMedicaidConsumerChange(event: MatRadioChange<boolean>): void {
    this.tripRequest.get("anotherMedicaidConsumer")?.setValue(event.value);
  }

  get ShowRoundTrip() : FormControl {
    return this.tripRequest.get("showRoundTrip") as FormControl;
  }
  
  setAddressSearchList() {
      this.tripAddressFr.controls.forEach((control: AbstractControl, i) => {
          this.providerAddress$.push(of([]));
          this.filteredAddress$[i] = this.tripRequestFormService.getSearchAddressList(control as FormGroup);
      });
  }
  
  addAdditionalStop() {
      this.tripRequest.get('showRoundTrip')?.setValue(false);
      this.tripRequest.get('isRoundTrip')?.setValue(false);
      const newStop = this.tripRequestFormFactory.getTripAddressFg(this.tripAddressFr.controls.length);
      this.tripAddressFr.push(newStop);
      this.tripAddressFr.at(this.tripAddressFr.controls.length-1).get('seqNo')?.setValue(this.tripAddressFr.controls.length);
      this.providerAddress$.push(of([]));
      this.filteredAddress$[this.tripAddressFr.controls.length-1] = this.tripRequestFormService.getSearchAddressList(newStop);

  }
  
  onAddressSelected(event: MatAutocompleteSelectedEvent, index: number): void {
    this.tripRequestFormService.validateSelectedAddress(this.tripAddressFr, event.option.value, index);
    this.tripAddressFr.at(index).get('isManualAddress')?.setValue(true);
    this.tripAddressFr.at(index).get('isMapAddress')?.setValue(false);
  }

  onAddressEntered(index: number) {
      this.tripAddressFr.at(index).get('isManualAddress')?.setValue(true);
      this.tripAddressFr.at(index).get('isMapAddress')?.setValue(false);
  }

  onAppointmentTypeChange(event: MatSelectChange): void {
      this.appointmentTypesList$.pipe(
        map(items => items.find(item => item.id === event.value)),
      ).subscribe(item => {
          this.showAppointmentType = item?.appointmentTypeName.trim() === 'Other'
          this.tripRequestFormService.selectedAppointmentType = item?.appointmentTypeName.trim()!;
          this.tripRequest.get('appointmentType')?.reset();
      });

      this.tripRequestService.getVerificationDocuments(this.recipientId,  event.value).subscribe(data => {
        this.linkingDocuments = data;
        this.dataSource.data = data;
      })


  }

  IsOtherCategory(selectedCategory : string) : boolean {
      return Number(selectedCategory) === OTHER_ADDRESS_CATEGORY
  }
  
  getSubRowClass(addressIndex: number): string {
    if (this.tripRequest.get('showRoundTrip')?.value === true) {
        if (this.tripAddressFr.length === addressIndex + 1) {
          return 'round-trip-container'
        }
        else {
          return 'right-bottom-container'
        }
      }
      return 'right-bottom-container'
  }

  onSelectAddressfromMap(addressIndex: number): void {
    const dialogRef = this.dialog.open(WidgetComponent, {
        width: '80%',
        height: '70%'
      });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
          if (!this.tripAddressFr.at(addressIndex-1).get('locationMannualEntry')?.value) {
              this.tripAddressFr.at(addressIndex-1).get('selectedAddress')?.setValue('');
          }
          if (!this.tripAddressFr.at(addressIndex).get('locationMannualEntry')?.value) {
              this.tripAddressFr.at(addressIndex).get('selectedAddress')?.setValue('');
          }

          if (this.tripAddressFr.at(addressIndex-1).get('addressCategoryId')?.value !== HOME_ADDRESS_CATEGORY) {
            this.tripAddressFr.at(addressIndex-1).get('address')?.setValue(result.startingAddress.trim());
            this.tripAddressFr.at(addressIndex-1).get('isManualAddress')?.setValue(false);
            this.tripAddressFr.at(addressIndex-1).get('isMapAddress')?.setValue(true);
          }

          if (this.tripAddressFr.at(addressIndex).get('addressCategoryId')?.value !== HOME_ADDRESS_CATEGORY) {
            this.tripAddressFr.at(addressIndex).get('address')?.setValue(result.endingAddress.trim());
            this.tripAddressFr.at(addressIndex).get('isManualAddress')?.setValue(false);
            this.tripAddressFr.at(addressIndex).get('isMapAddress')?.setValue(true);
          }
      }
    });
  }
  
  onEnterLocationManual(frmControl: AbstractControl | null) {
    frmControl!.setValue(true);
  }

  onEnterExistingLocation(frmControl: AbstractControl | null) {
    frmControl!.setValue(false);
  }

  onRoundTripChange($event: MatCheckboxChange) {
    this.tripRequest.get('showAdditionalStop')?.setValue(!$event.checked)
  }

  removeStopping(addressIndex: number) {
    this.tripAddressFr.removeAt(addressIndex);
    if (this.tripAddressFr.length == 2)
    {
      this.tripRequest.get('showRoundTrip')?.setValue(true);
    }
    this.providerAddress$.splice(addressIndex, 1);
    this.filteredAddress$.splice(addressIndex, 1);
  }

  onProviderAddressChange(event: MatSelectChange, addressIndex: number ) {
      this.tripAddressFr.at(addressIndex).get('address')?.setValue(event.value);
      this.tripAddressFr.at(addressIndex).get('isManualAddress')?.setValue(false);
      this.tripAddressFr.at(addressIndex).get('isMapAddress')?.setValue(false);
  }

  onAddressCategoryChange(event: MatSelectChange, addressIndex: number ) {
    this.recipientaddressCategories$.pipe(
      map(categories => categories.find(category => category.categoryId === event.value))
    ).subscribe(category => {
      this.tripAddressFr.at(addressIndex).get('otherCategoryType')?.setValue(category?.categoryName ?? event.value);
    });

    this.providerAddress$[addressIndex] = this.tripRequestService
                                          .getTripAndSavedAddresses(this.recipientId,this.countyCode,event.value);

    if (event.value == HOME_ADDRESS_CATEGORY 
      || !this.tripAddressFr.at(addressIndex).get('isManualAddress')?.value 
      || !this.tripAddressFr.at(addressIndex).get('isMapAddress')?.value) {
        this.tripAddressFr.at(addressIndex).get('address')?.setValue('');
        this.tripAddressFr.at(addressIndex).get('isManualAddress')?.setValue(false);
        this.tripAddressFr.at(addressIndex).get('isMapAddress')?.setValue(false);
    }
  }
  
  getIsRoundTripControl(): FormControl {
    return this.tripRequest.get('isRoundTrip') as FormControl;
  }
  
  getAddressCaption(index: number) : string {
    if (index === 0) {
      return "Enter Starting Address"
    }
    else if (index === this.tripAddressFr.controls.length -1) {
      return "Enter Destination Address"
    }
    return "Enter Stoping Address";
  }

  tollFileSelect() {
    if (this.tollfileUpload)
    this.tollfileUpload.nativeElement.click()
  }

  appointmentFileSelect() {
    if (this.appointmentfileUpload)
      this.appointmentfileUpload.nativeElement.click()
  }

  parkingFileSelect() {
    if (this.parkingfileUpload)
        this.parkingfileUpload.nativeElement.click()
  }

  onFilesSelected(event: Event, source: string) {
    const input = event.target as HTMLInputElement;
    if (!input.files) return;

    const allowedExtensions = ['.pdf', '.jpg', '.jpeg', '.png', '.txt', '.doc', '.docx', '.xls', '.xlsx'];
    const allowedMimeTypes = [
      'application/pdf', 'image/jpeg', 'image/png', 'text/plain',
      'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ];

    const newFiles = Array.from(input.files);

    const validTypesOnly = newFiles.filter(file => {
      const extension = '.' + file.name.split('.').pop()?.toLowerCase();
      return allowedExtensions.includes(extension) || allowedMimeTypes.includes(file.type);
    });

    if (source === ExpenseType.Toll) {
        this.addTollDocuments(validTypesOnly);     
    }
    else if (source === 'appointment') {
      this.addAppointmentDocuments(validTypesOnly); 
    }
    else {
      this.addParkingDocuments(validTypesOnly); 
    }

    input.value = '';
  }

  addTollDocuments(files: File[]) {
    const uniqueNewFiles = files.filter(
        (newFile) => !this.tollDocumentsDto.some((existingFile) => existingFile.fileName === newFile.name)
    );
    const newDocuments = uniqueNewFiles.map((file, index) => ({
        documentId: 0,
        fileName: file.name,
        path: '',
        documentType: ExpenseType.Toll,
        file
      }));
    this.tollDocumentsDto.push(...newDocuments);
    const totalCount = this.tollDocumentsDto.length 
    this.tollFileSelectPlaceHolder = totalCount > 0 ? `${totalCount} file(s) selected` : 'Upload Toll Receipts';

  }
  
  addParkingDocuments(files: File[]) {
    const uniqueNewFiles = files.filter(
        (newFile) => !this.parkingDocumentsDto.some((existingFile) => existingFile.fileName === newFile.name)
    );
    const newDocuments = uniqueNewFiles.map((file, index) => ({
        documentId: 0,
        fileName: file.name,
        path: '',
        documentType: ExpenseType.Parking,
        file
      }));
    this.parkingDocumentsDto.push(...newDocuments);
    const totalCount = this.parkingDocumentsDto.length 
    this.parkingFileSelectPlaceHolder = totalCount > 0 ? `${totalCount} file(s) selected` : 'Upload Parking Receipts';

  }
  
  addAppointmentDocuments(files: File[]) {
    const uniqueNewFiles = files.filter(
        (newFile) => !this.appVerficationDocumentsDto.some((existingFile) => existingFile.fileName === newFile.name)
    );
    const newDocuments = uniqueNewFiles.map((file, index) => ({
        documentId: 0,
        fileName: file.name,
        path: '',
        documentType: 'Verification',
        file
      }));
    this.appVerficationDocumentsDto.push(...newDocuments);
    const totalCount = this.appVerficationDocumentsDto.length 
    this.appointmentFileSelectPlaceHolder = totalCount > 0 ? `${totalCount} file(s) selected` : 'Upload Appointment Documents';
  }

  removeFile(index: number, source: string): void {
    if (source === ExpenseType.Toll) {
      this.tollDocumentsDto.splice(index, 1)
      const totalCount = this.tollDocumentsDto.length 
      this.tollFileSelectPlaceHolder = totalCount > 0 ? `${totalCount} file(s) selected` : 'Upload Toll Receipts';
    }
    else if (source === 'appointment') {
      this.appVerficationDocumentsDto.splice(index, 1)
      const totalCount = this.appVerficationDocumentsDto.length 
      this.appointmentFileSelectPlaceHolder = totalCount > 0 ? `${totalCount} file(s) selected` : 'Upload Appointment Documents';        

    }
    else {
      this.parkingDocumentsDto.splice(index, 1)
      const totalCount = this.parkingDocumentsDto.length 
      this.parkingFileSelectPlaceHolder = totalCount > 0 ? `${totalCount} file(s) selected` : 'Upload Parking Receipts';

    }
  }

  onRowDoubleClick(panel: MatExpansionPanel, rowData: VerificationDocuments) {
    this.linkAppointmentsDocuments(rowData.fileNamesWithId);
    panel.close();
  }

  onLinkPanelOpen(){
    this.dataSource.paginator = this.paginator;
  }

  linkAppointmentsDocuments(fileNames: string) {
    const fileNameList: string[] = fileNames.split(','); 

    const fileObjs = fileNameList.map(value => {
      const [name, id] = value.split('|');
      return {name,id: Number(id)};
    });

    const uniqueNewFiles = fileObjs.filter(
        (newFile) => !this.appVerficationDocumentsDto.some((existingFile) => existingFile.fileName.trim() === newFile.name.trim())
    );

    const newDocuments = uniqueNewFiles.map((file, index) => ({
        documentId: 0,
        fileName: file.name.trim(),
        path: '',
        documentType: 'Verification',
        linkDocumentId: file.id
      }));
    this.appVerficationDocumentsDto.push(...newDocuments);
    const totalCount = this.appVerficationDocumentsDto.length 
    this.appointmentFileSelectPlaceHolder = totalCount > 0 ? `${totalCount} file(s) selected` : 'Upload Appointment Documents';
  }

  hasError(controlName: string, errorName: string): boolean {
    const control: AbstractControl | null = this.tripRequest.get(`${controlName}`);
    return !!control && control.hasError(errorName) && (control.dirty || control.touched);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.stateSub) {
      this.stateSub.unsubscribe();
    }
  }

}